export default "__VITE_ASSET__DSJS5CnT__"